import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core'
import { ActivatedRoute, Params, Router } from '@angular/router'
import { BehaviorSubject, Subscription } from 'rxjs'

import { ChangeDetectorRef } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import { Meta, Title } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { SquidexService } from '../../../../services/squidex.service'
import { isScullyGenerated, TransferStateService } from '@scullyio/ng-lib'
import { take } from 'rxjs/operators'

@Component({
  selector: 'flowaccount-job-openning-detail',
  templateUrl: './job-openning-detail.component.html',
  styleUrls: ['./job-openning-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class JobOpenningDetailComponent implements OnInit, OnDestroy {
  public jobNameUrl
  public jobNameText
  public subscriptions: Subscription[] = []
  public dataValue: BehaviorSubject<Array<any>> = new BehaviorSubject<Array<any>>([])
  public jobsList
  private contentScully = 'JOB_DETAIL_KEY'
  private langChangeSubscription: Subscription

  constructor(
    private activatedRoute: ActivatedRoute,
    public translate: TranslateService,
    private titleService: Title,
    private seoService: SEOService,
    private cdref: ChangeDetectorRef,
    private router: Router,
    public readonly squidexService: SquidexService,
    protected tstate: TransferStateService,
    private meta: Meta,
  ) {
    this.activatedRoute.params.subscribe((params: Params) => {
      this.jobNameUrl = params['jobNameUrl']
      this.setMeta()
    })
  }

  ngOnInit() {
    if (isScullyGenerated()) {
      this.tstate.useScullyTransferState(this.contentScully, this.jobsList).subscribe((data: object[]) => {
        this.dataValue.next(data)
        this.filterAccountantList()
        this.cdref.markForCheck()
      })
    } else {
      // run every build
      this.getJobDetail()
    }
  }

  public getJobDetail() {
    this.subscriptions.push(
      this.squidexService
        .getContentSquidexApi('job-list')
        .pipe(take(1))
        .subscribe((data: any[]) => {
          this.dataValue.next(data)
          this.filterAccountantList()
          this.setMeta()
          this.tstate.setState(this.contentScully, data)
          this.cdref.markForCheck()
        }),
    )
  }

  setMeta() {
    this.jobNameText = {
      jobName: this.jobNameUrl.replace('-', ' '),
    }
    const metaTitle = this.translate.instant('metatitle-Jobs-Detail', this.jobNameText)
    const metaDescription = this.translate.instant('metaDescription-Jobs-Detail', this.jobNameText)
    this.titleService.setTitle(metaTitle)
    this.seoService.createCanonicalURL(metaDescription)
    this.seoService.createOg(
      'https://flowaccountcdn.com/new_landing/image/image_career.png',
      metaTitle,
      metaDescription,
    )
  }

  ngOnDestroy() {
    this.subscriptions.forEach((x) => x.unsubscribe())
    this.langChangeSubscription?.unsubscribe()
  }

  protected filterAccountantList() {
    this.jobsList = this.dataValue?.value?.filter((item) => item.data.jobNameUrl.iv === this.jobNameUrl) ?? []
    if (
      this.jobsList.length === 0 &&
      this.jobNameUrl &&
      (this.router.url.startsWith('/jobs/position/') || this.router.url.startsWith('/en/jobs/position/'))
    ) {
      window.location.href = '/notfound'
    }
    this.cdref.markForCheck()
  }
}
